export default __webpack_public_path__ + "static/media/inrtoduction_image.2f5b2833.png";